import { usePetitionDetailsPageData, usePetitionDetailsPageUserData } from 'src/app/pages/petitionDetails/pageContext';

export function usePromoteCtaDisplayed(): boolean {
	const {
		data: {
			petition: { promotable },
		},
	} = usePetitionDetailsPageData();
	const {
		data: { ownPetition },
	} = usePetitionDetailsPageUserData();

	return promotable && !ownPetition;
}
